import { render } from "./Information.vue?vue&type=template&id=04f8c895&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import "./Information.vue?vue&type=style&index=0&id=04f8c895&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04f8c895"

export default script